<template>
  <div>
    <el-form-item label="投放日期" prop="delivery_setting.schedule_type">
      <el-radio-group v-model="projectForm.delivery_setting.schedule_type">
        <el-radio-button ghost :label="SCHEDULE_TYPE.FROM_NOW"> 长期投放 </el-radio-button>
        <el-radio-button ghost :label="SCHEDULE_TYPE.START_END"> 指定日期 </el-radio-button>
        <el-radio-button v-if="standardEdit" ghost :label="SCHEDULE_TYPE.SEVEN_DAYS"> 投放7天 </el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item v-if="projectForm.delivery_setting.schedule_type === SCHEDULE_TYPE.START_END" prop="delivery_setting.date_range">
      <div v-if="standardEdit" class="standard-edit-date-range">
        <el-input :value="projectForm.delivery_setting.date_range[0]" disabled style="width: 220px"></el-input>
        <span>至</span>
        <el-date-picker
          v-model="projectForm.delivery_setting.date_range[1]"
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="{ disabledDate }"
          placeholder="选择结束日期"
          style="width: 220px"
        ></el-date-picker>
      </div>
      <DateRangePicker
        v-else
        v-model="projectForm.delivery_setting.date_range"
        :picker-options="{ disabledDate }"
        style="width: 320px"
      ></DateRangePicker>
    </el-form-item>

    <el-form-item label="投放时段" prop="delivery_setting.schedule_time_type">
      <el-radio-group v-model="projectForm.delivery_setting.schedule_time_type">
        <el-radio-button ghost :label="SCHEDULE_TIME_TYPE.ALL"> 全部时段 </el-radio-button>
        <el-radio-button ghost :label="SCHEDULE_TIME_TYPE.RANGE"> 指定时段 </el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item v-if="projectForm.delivery_setting.schedule_time_type === SCHEDULE_TIME_TYPE.RANGE" prop="delivery_setting.schedule_time">
      <DragWeektime v-model="projectForm.delivery_setting.schedule_time" :data="weektimeData" @change="onWeektimeChange"></DragWeektime>
    </el-form-item>

    <!-- 极速智投不能设置竞价策略 -->
    <el-form-item label="竞价策略" prop="delivery_setting.bid_type">
      <el-radio-group v-model="projectForm.delivery_setting.bid_type" :disabled="standardEdit" @change="onBidTypeChange">
        <!-- 稳定成本：ad_type = SEARCH & delivery_type = DURATION 即投放搜索极速智投广告时，仅支持CUSTOM（传入其他值不会生效） -->
        <el-radio-button ghost :label="BID_TYPE.CUSTOM"> 稳定成本 </el-radio-button>
        <!-- 最优成本： 当 ad_type=SEARCH时不支持、landing_type = APP/MICRO_GAME，delivery_mode = PROCEDURAL自动投放不支持 -->
        <el-radio-button ghost :label="BID_TYPE.UPPER_CONTROL" :disabled="isProcedural || isSearch"> 最优成本 </el-radio-button>
        <el-radio-button ghost :label="BID_TYPE.NO_BID" :disabled="isDuration || isFirstRoiGoal"> 最大转化 </el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item
      v-if="!isV3 && projectForm.delivery_setting.bid_type === BID_TYPE.CUSTOM"
      label="潜力探索"
      prop="delivery_setting.bid_type_upgrade"
    >
      <el-radio-group v-model="projectForm.delivery_setting.bid_type_upgrade">
        <el-radio-button ghost :label="BID_TYPE.CUSTOM"> 常规版 </el-radio-button>
        <el-radio-button ghost :label="BID_TYPE.EXPLORE_UPGRADE"> 升级版 </el-radio-button>
      </el-radio-group>

      <p class="important-notice">注意：潜力探索-升级版为【白名单功能】，未开通请勿选择</p>
    </el-form-item>

    <el-form-item label="计费方式" prop="delivery_setting.pricing">
      <el-radio-group v-model="projectForm.delivery_setting.pricing" :disabled="standardEdit">
        <el-radio-button ghost :label="PRICING_TYPE.PRICING_OCPM"> oCPM </el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="日预算" prop="delivery_setting.budget_mode">
      <el-radio-group v-model="projectForm.delivery_setting.budget_mode" :disabled="standardEdit" @change="onBudgetModeChange">
        <el-radio-button ghost :label="BUDGET_MODE.INFINITE" :disabled="isProcedural"> 不限 </el-radio-button>
        <el-radio-button ghost :label="BUDGET_MODE.DAY"> 日预算 </el-radio-button>
      </el-radio-group>
      <div v-if="projectForm.delivery_setting.budget_mode === BUDGET_MODE.DAY" class="row-gap">
        <el-input style="width: 320px" v-model="projectForm.delivery_setting.budget" placeholder="10 ~ 1000000">
          <template slot="append">元</template>
        </el-input>
      </div>
    </el-form-item>

    <!-- 当bid_type=NO_BID且BUDGET=BUDGET_MODE_DAY时,“预算择优分配”必填; -->
    <el-form-item label="预算择优分配(CBO)" v-if="budgetOptimizeSwitchVisible && !standardEdit">
      <el-radio-group v-model="projectForm.delivery_setting.budget_optimize_switch">
        <el-radio-button ghost :label="BUDGET_OPTIMIZE_SWITCH.OFF"> 不启用 </el-radio-button>
        <el-radio-button ghost :label="BUDGET_OPTIMIZE_SWITCH.ON"> 启用 </el-radio-button>
      </el-radio-group>
    </el-form-item>

    <!-- 只有模板新建计划时显示 -->
    <template v-if="isTemplate">
      <el-form-item label="优化目标">
        <el-radio-group v-model="projectForm.delivery_setting.optimize_goal.external_action" @change="onExternalTypeChange">
          <el-radio-button ghost :label="EXTERNAL_ACTION.PAY"> 付费 </el-radio-button>
          <el-radio-button ghost :label="EXTERNAL_ACTION.ACTIVE"> 激活 </el-radio-button>
          <el-radio-button ghost :label="EXTERNAL_ACTION.ACTIVE_REGISTER"> 注册 </el-radio-button>
          <el-radio-button ghost :label="EXTERNAL_ACTION.GAME_ADDICTION"> 关键行为 </el-radio-button>
        </el-radio-group>
      </el-form-item>
    </template>

    <el-form-item label="深度优化方式">
      <el-radio-group
        v-model="projectForm.delivery_setting.optimize_goal.deep_bid_type"
        :disabled="standardEdit"
        @change="onDeepBidTypeChange"
      >
        <el-radio-button ghost :label="DEEP_BID_TYPE.DEFAULT"> 无 </el-radio-button>
        <el-radio-button ghost v-if="deepBidTypeVisible.bidPerAction" :label="DEEP_BID_TYPE.BID_PER_ACTION"> 每次付费 </el-radio-button>
        <el-radio-button ghost v-if="deepBidTypeVisible.roiCoefficient" :label="DEEP_BID_TYPE.ROI_COEFFICIENT"> ROI系数 </el-radio-button>
        <el-radio-button ghost v-if="deepBidTypeVisible.firstDayRoiSevenDayRoi" :label="DEEP_BID_TYPE.FIRST_AND_SEVEN_PAY_ROI">
          首日ROI+7日ROI
        </el-radio-button>
        <el-radio-button ghost v-if="deepBidTypeVisible.bidPerActionSevenDayRoi" :label="DEEP_BID_TYPE.PER_AND_SEVEN_PAY_ROI">
          每次付费+7日ROI
        </el-radio-button>
      </el-radio-group>
    </el-form-item>

    <template v-if="isFirstRoiGoal">
      <el-form-item :key="projectForm.delivery_setting.optimize_goal.deep_bid_type" label="首日ROI" prop="delivery_setting.first_roi_goal">
        <el-input v-model="projectForm.delivery_setting.first_roi_goal" style="width: 320px" placeholder="0.0001 ~ 5"></el-input>
      </el-form-item>
    </template>
    <template v-else>
      <!-- 项目出价：只有自动投放和竞价策略为稳定成本时需要配置 -->
      <!-- tg4.46 新增搜索广告的极速智投可以设置项目出价 -->
      <el-form-item
        :key="projectForm.delivery_setting.optimize_goal.deep_bid_type"
        label="目标出价"
        v-show="projectBidVisible"
        prop="delivery_setting.cpa_bid"
      >
        <el-radio-group v-if="!standardEdit" v-model="projectForm.delivery_setting.bid_value_type">
          <el-radio-button ghost :label="BID_VALUE_TYPE.FIXED"> 固定出价 </el-radio-button>
          <el-radio-button ghost :label="BID_VALUE_TYPE.RANGE"> 随机区间出价 </el-radio-button>
        </el-radio-group>
        <div style="margin-top: 10px">
          <el-input
            v-if="projectForm.delivery_setting.bid_value_type === BID_VALUE_TYPE.FIXED"
            v-model="projectForm.delivery_setting.cpa_bid"
            style="width: 320px"
            placeholder="0.01 ~ 10000元"
          ></el-input>
          <InputRange v-else v-model="projectForm.delivery_setting.bid_num_range" placeholder="金额"> </InputRange>
        </div>
      </el-form-item>
    </template>

    <template v-if="adDeepBidVisible && (standardEdit || isTemplate || isDuplicate || isModify)">
      <el-form-item label="深度优化目标">
        <el-radio-group v-model="projectForm.delivery_setting.optimize_goal.deep_external_action" :disabled="standardEdit">
          <el-radio-button ghost v-if="deepExternalActionVisible.purchaseRoi" :label="DEEP_EXTERNAL_ACTION.PURCHASE_ROI">
            付费ROI
          </el-radio-button>
          <el-radio-button ghost v-if="deepExternalActionVisible.purchaseRoiSevenDay" :label="DEEP_EXTERNAL_ACTION.PURCHASE_ROI_7D">
            付费ROI-7日
          </el-radio-button>
          <el-radio-button ghost v-if="deepExternalActionVisible.monetizationRoi" :label="DEEP_EXTERNAL_ACTION.LT_ROI">
            变现ROI
          </el-radio-button>
          <el-radio-button ghost v-if="deepExternalActionVisible.monetizationRoiSevenDay" :label="DEEP_EXTERNAL_ACTION.LTV_ROI_SEVEN">
            变现ROI-7日
          </el-radio-button>
          <el-radio-button ghost v-if="deepExternalActionVisible.purchaseRoiThirtyDay" :label="DEEP_EXTERNAL_ACTION.PURCHASE_ROI_THIRTY">
            付费ROI-30日
          </el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="深度目标出价" v-show="projectBidVisible" prop="delivery_setting.roi_goal">
        <el-radio-group v-if="!standardEdit" v-model="projectForm.delivery_setting.roi_bid_value_type">
          <el-radio-button ghost :label="BID_VALUE_TYPE.FIXED"> 固定roi </el-radio-button>
          <el-radio-button ghost :label="BID_VALUE_TYPE.RANGE"> 随机区间roi </el-radio-button>
        </el-radio-group>
        <div style="margin-top: 10px">
          <el-input
            v-if="projectForm.delivery_setting.roi_bid_value_type === BID_VALUE_TYPE.FIXED"
            v-model="projectForm.delivery_setting.roi_goal"
            style="width: 320px"
            placeholder="0.0001 ~ 5"
          ></el-input>
          <InputRange v-else v-model="projectForm.delivery_setting.roi_bid_num_range"> </InputRange>
        </div>
      </el-form-item>
    </template>
  </div>
</template>

<script setup>
import { ref, unref, inject, reactive, onMounted, computed } from 'vue'
import weektimeData from '@/data/tencent/weektime_data'
import {
  DELIVERY_TYPE,
  SCHEDULE_TYPE,
  SCHEDULE_TIME_TYPE,
  BID_TYPE,
  PRICING_TYPE,
  BUDGET_MODE,
  BUDGET_OPTIMIZE_SWITCH,
  BID_VALUE_TYPE,
  EXTERNAL_ACTION,
  DEEP_EXTERNAL_ACTION,
  DEEP_BID_TYPE
} from '../../consts/index.js'
import { useProjectForm } from './useProject.js'
import { useOptimizeGoalRelative } from '../../hooks/useOptimizeGoal.js'
import { usePageStates } from '../../hooks/useCommonComputeds.js'

import DateRangePicker from '@/components/date-range-picker/index.vue'
import InputRange from '@/views/edit/kuaishou/components/input-range'
import DragWeektime from '@/views/edit/kuaishou/components/time-range/index.vue'
// eslint-disable-next-line
const props = defineProps({
  form: Object,
  standardEdit: {
    type: Boolean,
    default: false
  }
})

const disabledDate = (date) => {
  return date && date.valueOf() < Date.now() - 86400000
}
const { isTemplate, isModify, isDuplicate } = usePageStates()
const projectForm = computed(() => props.form)
const standardEdit = computed(() => props.standardEdit)
const { isV3 } = inject('bytedanceVersion', { isV3: computed(() => false) })
const [
  { budgetOptimizeSwitchVisible, deepBidTypeVisible, deepExternalActionVisible },
  { onPlatformChange, onGameChange, onExternalTypeChange, onBidTypeChange, onDeepBidTypeChange, onBudgetModeChange }
] = useProjectForm(projectForm)

const { isSearch, isNormal, isDuration, isProcedural, isFirstRoiGoal, adDeepBidVisible, projectBidVisible } =
  useOptimizeGoalRelative(projectForm)

/**
 * @description: 回显投放时间区间，保存到projectForm，用于项目信息预览显示
 * @param {*} schedule
 * @param {*} readableWeekdays
 */
function onWeektimeChange(schedule, readableWeekdays) {
  projectForm.value.delivery_setting.readableWeekdays = readableWeekdays
}
</script>

<style lang="scss" scoped>
.row-gap {
  margin-top: 10px;
}
.standard-edit-date-range {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
